import InstantSearchInput from '@/components/InstantSearchInput';
import { PendoPlaceholder } from '@/components/PendoPlaceholder';

const LoginAsHeader = () => {
  return (
    <div className="flex items-center justify-end">
      <div className="flex items-center gap-2">
        <PendoPlaceholder />
        <InstantSearchInput />
      </div>
    </div>
  );
};

export default LoginAsHeader;
